import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-camera-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl text-background-50">91自拍论坛</span>
            </div>
            <p className="text-sm leading-relaxed text-background-50/60">
              专为摄影爱好者打造的自拍技巧交流平台，汇聚海量自拍教程、构图技巧、光线运用与后期修图经验分享。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50 mb-4">内容分类</h3>
            <ul className="flex flex-col gap-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50 mb-4">快速链接</h3>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
              </li>
              <li>
                <Link to="/category/composition" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">热门教程</Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50 mb-4">联系方式</h3>
            <ul className="flex flex-col gap-3 text-sm text-background-50/60">
              <li className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-sm"></i>
                </div>
                <span>contact@91selfie.com</span>
              </li>
              <li className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-line text-sm"></i>
                </div>
                <span>北京市朝阳区摄影创意园</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/40">
            &copy; {new Date().getFullYear()} 91自拍论坛 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-sm text-background-50/70"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-sm text-background-50/70"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="小红书">
              <i className="ri-red-packet-line text-sm text-background-50/70"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}